<template>
    <div>
        <title>券卡出库</title>
        <article class="cardArticle">
            <section class="cardCon">
                <header class="tabHeader">
                    <p>
                        <router-link class="isActive" :to="{path:'/CardsOut'}" v-if="openStoreDefinition==1">券卡定义激活</router-link>
                        <router-link :to="{path:'/CardsActivation'}">券卡激活</router-link>
                        <router-link :to="{path:'/CardsPause'}">券卡暂停</router-link>
                        <router-link :to="{path:'/CardsReuse'}">券卡恢复</router-link>
                        <router-link :to="{path:'/CardsRecover'}" v-if="ElementControls('erjimendian')==1">销售回收</router-link>
                        <router-link :to="{path:'/CardMdShop'}" v-if="ElementControls('erjimendian')==1">门店铺券</router-link>
                    </p>
                </header>
                <CardOut :type="0"></CardOut>
            </section>
        </article>
    </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "CardsOut",
  // ==================================== 组件====================================
  components: {
    CardOut: resolve => require(["@/components/CardsFolder/CardOut.vue"],resolve), // 出库组件
  },
  data() {
    return {
      openStoreDefinition:0,
			cardqupd:0,
    }
  },
  // ============================================== 监听 ==============================================
  watch: {
  },
   // ==================================== 计算属性 ====================================
    computed: {
      ...mapState({
        bdis: ({ common }) => common.bdis,
      })
    },
  // ============================================== 方法 ==============================================
  methods: {

  },
	mounted() {
    this.openStoreDefinition = this.ElementControls('openStoreDefinition');
		this.cardqupd =this.ElementControls('cardqupd')
	}
  
};
</script>
<style scoped>
.cardArticle{padding: 20px;}
.cardCon {
  position: relative;
  padding: 84px 20px 85px 0;
  height: calc(100% - 169px);
}
.cardWrap {
  margin-top: 10px;
}
.zoneHead {
  -ms-box-sizing: border-box;
  -o-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
@media (max-width: 1310px) {
  .cardCon header a {
    padding: 0 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/CardsFolder/CardsGift/CardManage/CardsOut.vue